import PropTypes from "prop-types"
import React, { Fragment, useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Box, Typography, Checkbox, CircularProgress } from "@material-ui/core"
import moment from "moment"
import CheckIcon from "@material-ui/icons/Check"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"

import classNames from "classnames"
import useStyles from "./styles"
import { markPaymentReceived } from "../../../../actions/billing"
import { openSnackBar } from "../../../../actions/snack-bar"

const EstimateStatusCard = ({ amounts = {} }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [checkboxLoading, toggleCheckboxLoading] = useState(false)
  // const [depositPaidAmount, setDepositPaidAmount] = useState(Boolean(generalData.deposit_required)
  // ? generalData.first_half_amount
  // : 0)
  // const [partialPaymentReceived, setPartialPaymentRecieved] = useState(depositPaidAmount > 0 && Boolean(generalData.first_paid))

  const generalData = useSelector(state => state.billing.generalData)
  // debugger;
  const estimateAccepted = generalData && Boolean(generalData.estimate_accepted)
  const depositRequired = generalData && Boolean(generalData.deposit_required)
  // THIS IS THE DEPOSITPAIDAMOUNT THAT NEEDS TO GET UPDATED FASTER FOR THE ESTIMATE
  const depositPaidAmount = Boolean(generalData.deposit_required)
    ? generalData.first_half_amount
    : 0
  const partialPaymentReceived =
    depositPaidAmount > 0 && Boolean(generalData.first_paid)
  const paymentType = depositRequired && generalData.first_payment_type

  // WAS MESSING AROUND TRYING TO GET IT TO RERENDER THE DATA
  // useEffect(() => {
  //   setDepositPaidAmount(Boolean(generalData.deposit_required)
  //   ? generalData.first_half_amount
  //   : 0)
  //   setPartialPaymentRecieved(depositPaidAmount > 0 && Boolean(generalData.first_paid))
  // }, [generalData, depositPaidAmount])

  const markCheckAsReceived = () => {
    toggleCheckboxLoading(true)
    let checked = generalData && generalData.first_paid === 1
    let callData = {
      paidColumn: "first_paid",
      paymentStatus: checked ? 0 : 1,
    }
    let updateData = {
      first_paid: checked ? 0 : 1,
      first_paid_date: checked ? null : moment().format(),
    }

    let invoiceId = generalData.client_invoice_id
    dispatch(markPaymentReceived(callData, invoiceId, updateData))
      .then(() => {
        dispatch(
          openSnackBar({
            message: `Marked payment as ${
              checked ? "not received" : "received"
            }`,
          })
        )
        toggleCheckboxLoading(false)
      })
      .catch(err => {
        console.log(err)
        toggleCheckboxLoading(false)
        dispatch(
          openSnackBar({ message: "Unable to change payment received status" })
        )
      })
  }

  return (
    <Box mb={2} mt={2}>
      <Box display="flex" flexDirection="column" mb={3}>
        <Box className={classes.rowWrapper}>
          <Typography style={{ fontSize: "18px", fontWeight: 600 }}>
            {estimateAccepted ? "Estimate Accepted" : "Pending Approval"}
          </Typography>
          <Box
            className={classNames(classes.statusDot, {
              [classes.acceptedDot]: estimateAccepted,
            })}
          >
            {estimateAccepted && <CheckIcon className={classes.checkIcon} />}
          </Box>
        </Box>
        {!estimateAccepted ? (
          <Typography className={classes.grayFont}>
            Sent{" "}
            {moment(generalData.estimate_sent_date_time).format(
              "M/D/YY[ @ ]h:mm A"
            )}
          </Typography>
        ) : (
          <Typography className={classes.grayFont}>
            Accepted{" "}
            {moment(generalData.estimate_accepted_date_time).format(
              "M/D/YY[ @ ]h:mm A"
            )}{" "}
            by {generalData.client_estimate_signature}
          </Typography>
        )}
      </Box>
      {/* bottom part */}
      <Box display="flex" flexDirection="column">
        {depositRequired ? (
          <Fragment>
            <Box className={classes.rowWrapper}>
              <Typography variant="h3">
                {partialPaymentReceived
                  ? "Payment Received"
                  : depositPaidAmount > 0
                    ? "Partial Payment Sent"
                    : "Partial Payment"}
              </Typography>
              <Box
                className={classNames(classes.statusDot, {
                  [classes.acceptedDot]: partialPaymentReceived,
                })}
              >
                {partialPaymentReceived && (
                  <CheckIcon className={classes.checkIcon} />
                )}
              </Box>
            </Box>
            {!partialPaymentReceived &&
              !depositPaidAmount && (
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginTop: 10,
                    alignSelf: "flex-start",
                  }}
                >
                  Partial Payment request for:
                </Typography>
              )}
            <Box className={classes.rowWrapper}>
              <Typography className={classes.greenFont}>
                50% of estimate
              </Typography>
              <Typography className={classes.greenFont}>
                ${depositPaidAmount > 0
                  ? formatNumberWithCommas(depositPaidAmount)
                  : formatNumberWithCommas(amounts.half)}
              </Typography>
            </Box>
            {depositPaidAmount > 0 && (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                textAlign="left"
              >
                {/* variable text based on payment type below: */}
                {paymentType === "credit-card" && (
                  <Typography className={classes.grayFont}>
                    Card ending in XXXX
                  </Typography>
                )}
                {paymentType === "check" && (
                  <Fragment>
                    <Typography className={classes.grayFont}>Check</Typography>
                    <Box
                      mt={2}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="25px"
                    >
                      {checkboxLoading ? (
                        <Box pl={2} pr={2} pt={1.5} pb={1.5}>
                          <CircularProgress size={16} />
                        </Box>
                      ) : (
                        <Checkbox
                          checked={generalData && generalData.first_paid === 1}
                          onChange={markCheckAsReceived}
                        />
                      )}
                      <Typography className={classes.grayFont}>
                        Mark payment{" "}
                        {generalData && generalData.first_paid === 1
                          ? "not received"
                          : "received"}
                      </Typography>
                    </Box>
                  </Fragment>
                )}
              </Box>
            )}
          </Fragment>
        ) : (
          <Typography
            style={{ fontSize: "16px", fontWeight: 600, textAlign: "left" }}
          >
            No deposit required
          </Typography>
        )}
      </Box>
    </Box>
  )
}

EstimateStatusCard.propTypes = {
  amounts: PropTypes.object,
}

export default EstimateStatusCard
